import { Component, ViewChild } from '@angular/core';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { TipoCambioService } from 'app/services/configuracion/tipo-cambio.service';
import { MatPaginator, MatSort, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatTableDataSource } from '@angular/material';


export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-lista-tipo-cambio',
  templateUrl: './lista-tipo-cambio.component.html',
  styleUrls: ['./lista-tipo-cambio.component.css'],
  providers: [
    DatePipe,
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListaTipoCambioComponent   {

  tipoCambio : any;
  abrirEditarTipoCambio : boolean;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  // usuarios:any[]=[];
  pageSizeOptions = [10,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean=false;
  displayedColumns: string[] = 
            ['checked','Fecha','Fuente','Compra','Venta','Vigente_Indicador'];
  dataSource = new MatTableDataSource( this.docNegociables) ;
  FFinal : Date = new Date();
  FInicial  : Date = new Date();
  Fuente : any = '';

  constructor( private tipoCambioService:TipoCambioService, private datePipe :DatePipe) { 

    this.abrirEditarTipoCambio = false;
  }

 

  cargarLstTiposDeCambio(){

    this.loading=true;
    this.tipoCambioService.obtenerTipoDeCambio(this.datePipe.transform (this.FInicial,'yyyy-MM-dd'),this.datePipe.transform (this.FFinal,'yyyy-MM-dd'),this.Fuente)
    .subscribe(res => {
     
      this.docNegociables = res;
      this.loading = false;
      this.dataSource = new MatTableDataSource( this.docNegociables);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

    });

  }

  btnEditar(fila :any){
  
    this.tipoCambio = fila;
    this.abrirEditarTipoCambio = true;
      
  }

  cerrarVentanaEditarTipoCambio(){
    this.abrirEditarTipoCambio = false;
  }
  

}
